module.exports = __webpack_public_path__ + "img/74400.e4fe0548.jpg";